/** @jsx jsx */

import { css, jsx } from '@emotion/react';
import * as colors from '@atlaskit/theme/colors';
import { themed, useGlobalTheme } from '@atlaskit/theme/components';
import { typesMapping } from '../../constants';
var iconColor = themed('appearance', {
  connectivity: {
    light: "var(--ds-icon-brand, ".concat(colors.B400, ")"),
    dark: "var(--ds-icon-brand, ".concat(colors.B100, ")")
  },
  confirmation: {
    light: "var(--ds-icon-success, ".concat(colors.G300, ")"),
    dark: "var(--ds-icon-success, ".concat(colors.G300, ")")
  },
  info: {
    light: "var(--ds-icon-discovery, ".concat(colors.P300, ")"),
    dark: "var(--ds-icon-discovery, ".concat(colors.P300, ")")
  },
  warning: {
    light: "var(--ds-icon-warning, ".concat(colors.Y300, ")"),
    dark: "var(--ds-icon-warning, ".concat(colors.Y300, ")")
  },
  error: {
    light: "var(--ds-icon-danger, ".concat(colors.R400, ")"),
    dark: "var(--ds-icon-danger, ".concat(colors.R400, ")")
  }
});
var iconWrapperStyles = css({
  display: 'flex',
  alignItems: 'center',
  flex: '0 0 auto',
  color: 'var(--icon-color)'
});
var iconColorStyles = css({
  color: 'var(--icon-accent-color)'
});

/**
 * __Selected icon__
 *
 * The selected icon is used as the primary interactive element for the dialog.
 * Can be used with or without supporting text.
 */
var SelectedIcon = function SelectedIcon(_ref) {
  var appearance = _ref.appearance,
    isOpen = _ref.isOpen,
    label = _ref.label;
  var _typesMapping$appeara = typesMapping[appearance],
    SelectedIcon = _typesMapping$appeara.icon,
    defaultLabel = _typesMapping$appeara.defaultLabel;
  var theme = useGlobalTheme();
  return jsx("span", {
    "data-ds--inline-message--icon": true,
    style: {
      '--icon-color': iconColor({
        appearance: appearance,
        theme: theme
      })
    },
    css: [iconWrapperStyles, isOpen && iconColorStyles]
  }, jsx(SelectedIcon, {
    testId: "inline-message-icon",
    label: label || defaultLabel,
    size: "medium"
  }));
};
export default SelectedIcon;